import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=469cc71a&scoped=true&"
import script from "./DocumentCategory.vue?vue&type=script&lang=js&"
export * from "./DocumentCategory.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/document_category.scss?vue&type=style&index=0&id=469cc71a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469cc71a",
  null
  
)

export default component.exports